module.exports = __webpack_public_path__ + "img/part2.f8dae8cc.jpg";